import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function XrfbudgetpsflineReducer(state = initialState.xrfbudgetpsflineContent, action: any) {
  switch (action.type) {
    case types.SAVE_XRFBUDGETPSFLINECONTENT_SUCCESS:
      return action.xrfbudgetpsflineContent;
    default:
      return state;
  }
}
